// extracted by mini-css-extract-plugin
export default {"small":"RALOqufmVil3dBgL4wG5"};